const initialState = {
    data: [],
  };
  
const logiReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_LOGI':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default logiReducer;